<template lang='pug'>
  div.c-footer
    .u-bg-dark(v-if='showInfo')
      nav(class='c-footer__nav o-wrapper u-pt4')
        div()
          router-link(:to="{ name: 'Home'}" class='u-block c-footer__logo')
            img(:src='company.logoUrl')

        div()
          p(class='u-uppercase u-color-primary u-mt0 u-fw-s-bold')
            i.u-icon.u-mb3 location&nbsp;
            span Ubicación
          p(class='u-white') {{ company.address }}

        div()
          p(class='u-uppercase u-color-primary u-mt0 u-fw-s-bold')
            i.u-icon.u-mb3 newspaper&nbsp;
            span Noticias
          ul(class='u-pl0 u-uppercase')
            li(v-for='category in categories' class='u-mb2')
              router-link(:to="{ name: 'SearchCategory', params: {slug: category.id}}" class=' u-white') {{category.name}}

        div()
          p(class='u-uppercase u-color-primary u-mt0 u-fw-s-bold')
            i.u-icon.u-mb3 cellphone&nbsp;
            span Central telefónica

          .u-mb1.u-white(v-if='company.pressPhone || company.pressCellphone')
            p.u-mr2.u-mb2 Prensa:
            span {{ company.pressPhone }} | {{ company.pressCellphone }}
          div.u-white(v-if='company.publicityPhone || company.publicityPhone')
            p.u-mr2.u-mb2 Publicidad:
            span {{ company.publicityPhone }} | {{ company.publicityCellphone }}

        div()
          p(class='u-uppercase u-color-primary u-mt0 u-fw-s-bold')
            i.u-icon.u-mb3 message_border&nbsp;
            span Correos

          p.u-white {{ company.email }}
    footer.u-bg-dark.u-center.u-py3.u-fz-h6.u-px3(v-if='showDeveloped')
      span.u-white.u-light
        | Copyright &copy {{ date.getFullYear() }} {{company.name}}. Todos los derechos reservados | Tacna - Perú | Desarrollado por&nbsp;
        a.u-color-primary.u-fw-s-bold(href='https://noveltie.la/', target='_blank') Noveltie
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'AppFooter',
    props: {
      showInfo: {
        type: Boolean,
        default: true
      },
      showDeveloped: {
        type: Boolean,
        default: true
      }
    },

    data () {
      return {
        date: new Date()
      }
    },

    computed: {
      ...mapGetters({
        company: 'company',
        categories: 'categories'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/AppFooter.vue